import { Record, List } from 'immutable';
import moment from 'moment';
import Address from './Address';
import PaymentMethod from './PaymentMethod';
import ShippingMethod from './ShippingMethod';
import InvoiceItem from './InvoiceItem';
import OrderItem from './OrderItem';
import Store from './Store';

const OrderDefaults = {
  id: null,
  order_number: null,
  store: null,
  shipping_method: null,
  shipping_address: null,
  payment_method: null,
  submitted_at: null,
  order_state: null,
  order_state_text: null,
  items: new List(),
  invoice: new List()
};

class Order extends Record(OrderDefaults) {
  constructor(values) {
    values.shipping_address = (values.shipping_address instanceof Address) ? values.shipping_address : new Address(values.shipping_address);
    values.payment_method = (values.payment_method instanceof PaymentMethod) ? values.payment_method : new PaymentMethod(values.payment_method);
    values.items = (new List(values.items)).map((oi) => {return (oi instanceof OrderItem ? oi :new OrderItem(oi));});
    values.invoice = (new List(values.invoice)).map((ii) => {return (ii instanceof InvoiceItem ? ii : new InvoiceItem(ii));});
    values.store = new Store(values.store);

    super(values);
  }

  get total_text() {
    return this.invoice.find(invoiceItem => {return invoiceItem.type === 'total';}).value;
  }

  get formatted_submitted_at() {
    return moment(this.submitted_at * 1000).format('MM/DD/YYYY');
  }
}

export default Order;



// WEBPACK FOOTER //
// banquet/models/Order.js